import React, { useState } from "react";
import "../ModalMouqabale.styles.scss";
import { TMiniProfil, TMouqabalaStep } from "@/features/profile/types";
import { Button, Checkbox } from "@mui/material";
import { InlineIcon } from "@iconify/react";
import { Toastify } from "@/utils/toast";
import LoaderMini from "@/components/Loader-mini/LoaderMini";
import { apiAskMouqabala } from "@/features/profile/api/mouqabala.api";

interface MouqStep2Props {
  setStep: React.Dispatch<React.SetStateAction<TMouqabalaStep>>;
  close?: () => void;
  receiver: TMiniProfil | null;
  conversation_id: string;
}
const MouqStep2 = ({
  setStep,
  close,
  receiver,

  conversation_id,
}: MouqStep2Props) => {
  const [checked, setChecked] = useState(false);
  const [loadingDemandeMouqabala, setLoadingDemandeMouqabala] = useState(false);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setChecked(event.target.checked);
  };

  const demanderMouqabala = () => {
    setLoadingDemandeMouqabala(true);
    apiAskMouqabala({
      id_receiver: receiver?._id || "",
      conversation_id: conversation_id,
    })
      .then((response: any) => {
        setLoadingDemandeMouqabala(false);
        console.log(response);

        setStep(3);
      })
      .catch((error) => {
        setLoadingDemandeMouqabala(false);
        setStep(3); //<----- juste pour les test à enlever après
        if (
          error?.response?.data?.message ===
          "Appointment request already exists"
        ) {
          Toastify(`Vous avez déjà envoyé une demande`, "warning", 5000);
        } else {
          Toastify(`${error?.response?.data?.message}`, "error", 5000);
        }
      });
  };

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: "30px" }}>
      <div className="rules confirm">
        <p className="rules__title">Règles d'une mouqabala ?</p>
        {loadingDemandeMouqabala ? (
          <LoaderMini />
        ) : (
          <>
            <div className="rules__item">
              <div className="number">
                <span>1</span>
              </div>
              <p className="text">
                {" "}
                Les prétendants doivent se connecter à l'heure et respecter le
                délai alloué à leurs mouqabala
              </p>
            </div>
            <div className="rules__item">
              <div className="number">
                <span>2</span>
              </div>
              <p className="text">
                {" "}
                Les prétendants doivent observer les mêmes règles au court de la
                rencontre que les règles présente sur le site en terme de
                respect et d'interdiction de complaisance.
              </p>
            </div>
            <div className="rules__item">
              <div className="number">
                <span>3</span>
              </div>
              <p className="text">
                {" "}
                Interdiction pour les prétendantes de se dévoiler !
              </p>
            </div>
            <div className="rules__item">
              <div className="number">
                <span>4</span>
              </div>
              <p className="text">
                {" "}
                Toute personne ne respectant pas les règles du site se verra
                exclu !
              </p>
            </div>
            <div
              className="rules__confirm"
              onClick={() => {
                setChecked((prev) => !prev);
              }}
            >
              <Checkbox
                color="secondary"
                checked={checked}
                onChange={handleChange}
                className="scale-150"
                icon={
                  <InlineIcon
                    icon="line-md:confirm-circle-to-circle-transition"
                    color="var(--ui-secondary)"
                  />
                }
                checkedIcon={
                  <InlineIcon icon="line-md:confirm-circle-twotone" />
                }
                inputProps={{ "aria-label": "controlled" }}
              />
              <p>J’accepte les règles de la Mouqabala sans réserve</p>
            </div>
          </>
        )}
      </div>
      <div className="btn-layout">
        <Button
          variant="outlined"
          className="btn-mouq"
          onClick={() => {
            close!();
          }}
          color="tertiary"
        >
          Annuler et retour à la discussion
        </Button>
        <Button
          variant="contained"
          className="btn-mouq"
          onClick={demanderMouqabala}
          endIcon={<InlineIcon icon="ic:outline-navigate-next" />}
          color="primary"
          disabled={!checked}
        >
          Envoyer une demande
        </Button>
      </div>
    </div>
  );
};

export default MouqStep2;
